app.service('cartStepAnalytics', function (front, log, orderConfig, cookie) {
	var config;

	function logEvent() {
		config = orderConfig.getData();
		if (typeof config.cartStepOrderInfo !== 'undefined') {
			let logEventData = prepareCartStepLogEventData(config.cartStepOrderInfo)
			log.event(logEventData);
			UACartStep(logEventData);
		}
	}

	function UACartStep(logEventData) {
		UA.push({
			event: 'cart_step',
			orderNumber: logEventData.f04,
			paymentTotal: logEventData.f05,
			paymentType: logEventData.f06,
			deliveryType: logEventData.f07,
			voucherCode: logEventData.f08,
			guestMode: logEventData.f09,
			cookie: logEventData.f11,
			productsCodes: logEventData.f12,
			cartStepMapping: logEventData.f13,
			frontUserId: logEventData.f14,
			orderType: logEventData.f16,
			deliveryDate: logEventData.f17,
			deliveryTime: logEventData.f18,
			userTypeCompany: logEventData.f19,
			cartRetrieve: logEventData.f20,
			outletWarehouseCode: logEventData.f21
		});
	}

	function filterDisallowedCartstepParams(data) {
		const cartStepParamsToClear = {
			'precart': ['f04', 'f06', 'f07', 'f08', 'f09', 'f10', 'f15', 'f17', 'f18', 'f19', 'f20'],
			'basket': ['f04', 'f06', 'f07', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'login': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'home-delivery': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'shop-delivery': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'inpost-delivery': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'mail-delivery': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'payment': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18'],
			'delivery-time': ['f04', 'f10', 'f15', 'f17', 'f18'],
			'summary': [],
			'finalize': [],
			'order-payment-module': [],
			'gift-card-order-selection': ['f04', 'f06', 'f07', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'gift-card-client-data': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18', 'f19'],
			'gift-card-payment': ['f04', 'f06', 'f10', 'f15', 'f17', 'f18'],
			'gift-card-order-payment-module': [],
		}
		if (front.page() && cartStepParamsToClear[front.page()]) {
			cartStepParamsToClear[front.page()].forEach(paramName => {
				if (data.hasOwnProperty(paramName)) {
					delete data[paramName];
				}
			})
		}
		return data;
	}

	function prepareCartStepLogEventData(cartStepOrderInfo) {
		var cartStepLogEventData = {
			id: 'cart_step',
		}
		// f04 : numer zamówienia
		// cartStepOrderInfo.orderNumber
		cartStepLogEventData.f04 = cartStepOrderInfo.orderNumber;

		// f05 : wartość koszyka 
		// cartStepOrderInfo.paymentTotal
		cartStepLogEventData.f05 = cartStepOrderInfo.paymentTotal;

		// f06 : typ płatności
		// cartStepOrderInfo.paymentType
		// APPLE_PAY	 - 	apple-pay
		// BLIK	 - 	blik
		// E_CARD	 - 	e-Karta
		// E_TRANSFER	 - 	e-Przelew
		// GOOGLE_PAY	 - 	google-pay
		// CASH	 - 	Płatność za pobraniem
		// GIFT_CARD	 - 	Karta Podarunkowa
		// LIQUIDATION_OF_DAMAGES	 - 	Likwidacja szkód
		// PAYU_PAY_LATER	 - 	payu-place-pozn
		// TRANSFER	 - 	Przelew tradycyjny
		// PAYU_INSTALMENTS	 - 	Raty PayU
		// INSTALMENT_IN_CREDIT_AGRICOLE	 - 	Raty przez Internet
		// INSTALMENT	 - 	Raty z Doradcą
		// UNKNOWN	 - 	nieokreślony
		// SHOP	 - 	W sklepie
		cartStepLogEventData.f06 = cartStepOrderInfo.paymentType;

		// f07 : typ dostawy
		// cartStepOrderInfo.deliveryType
		// COURIER	 - 	Kurier
		// HOME	 - 	Transport Euro
		// INPOST	 - 	Paczkomat
		// DELIVERY_POINT	 - 	Punkt odbioru
		// MAIL	 - 	np. Kod aktywacyjny
		// SHOP	 - 	odbiór w sklepie/rezerwacja
		// UNKNOWN	 - 	nieokreślony
		cartStepLogEventData.f07 = cartStepOrderInfo.deliveryType;

		// f08 : czy jest kod rabatowy
		// cartStepOrderInfo.voucherUsed == true/false
		// cartStepOrderInfo.voucherCode == number or ''
		cartStepLogEventData.f08 = cartStepOrderInfo.voucherUsed == 'true' ? cartStepOrderInfo.voucherCode : '';

		// f09 : Czy zakupy są prowadzone jako gość
		cartStepLogEventData.f09 = cartStepOrderInfo.guestMode;

		// f10 : ''
		// cartStepLogEventData.f10 = ''; // nie wysyłamy pustego

		// f11 : numer koszyka
		var cookieCart = front.euro ? 'euroCart' : 'oleoleCart';
		cartStepLogEventData.f11 = config.giftCardOrderPath ? '' : cookie.get(cookieCart);

		// f12 : Plu produktów w koszyku, po średniku
		cartStepLogEventData.f12 = cartStepOrderInfo.productsCodes;

		// f13 : krok koszyka
		// PG	 	- 	potykacz PG
		// K0	 	- 	K0 => brak w RWD
		// cart	 	- 	K1
		// login	 	- 	Logowanie
		// order-home-delivery	 - 	Adres dostawy
		// order-payment	 - 	Sposób płatnosci
		// order-delivery-time	 - 	Kalendarz
		// order-module	 	- 	Moduł płaności
		// order-finalize	- 	Złożenie zamówienia
		// order-summary	- 	podsumowanie zamówienia (mobile)
		var cartStepMapping = {
			'basket': $('#basket.delivery-mode').length ? 'basket-delivery' : 'cart',
			'login': 'login',
			'home-delivery': 'order-delivery',
			'delivery': 'order-delivery',
			'payment': 'order-payment',
			'delivery-time': 'order-delivery-time',
			'deliveryTime': 'order-delivery-time',
			'order-payment-module': 'order-module',
			'finalize': 'order-finalize',
			'summary': 'order-summary',
			'gift-card-order-selection': 'cart',
			'gift-card-client-data': 'order-delivery',
		}
		cartStepLogEventData.f13 = config.pageType && cartStepMapping[config.pageType] ? cartStepMapping[config.pageType] : (cartStepMapping[front.page()] ? cartStepMapping[front.page()] : front.page());

		// f14 : czy zalogowany, jeśli tak to numer KME
		cartStepLogEventData.f14 = front.page() == 'login' ? '' : cartStepOrderInfo.frontUserId;

		// f15 : '' //czy było K0
		// cartStepLogEventData.f15 = ''; // nie wysyłamy pustego

		// f16 : ścieżka ratalna
		//cartStepOrderInfo.isInstalmentPayment
		cartStepLogEventData.f16 = cartStepOrderInfo.isInstalmentPayment == 'true' ? 'INSTALLMENT' : 'CASH';

		// f17 : wybrany temin dostawy
		cartStepLogEventData.f17 = cartStepOrderInfo.deliveryDate;

		// f18 : wybrana godzina dostawy
		cartStepLogEventData.f18 = cartStepOrderInfo.deliveryTime;

		// f19 : czy na firmę
		// cartStepOrderInfo.userTypeCompany
		cartStepLogEventData.f19 = cartStepOrderInfo.userTypeCompany == 'true' ? cartStepOrderInfo.userTypeCompanyNumber : '';

		// f20 : Czy wyświetliło się łączenie koszyka? (krok k3 dane dostawy - akcja na widoku 'cart-retrieve.jsp' oraz )
		// nie wyświetlił się: false
		// wyświetlił ale zostało zignorowane: true
		// wyświetlił się i koszyk nadpisany starym koszykiem: previous
		// wyświetlił się i koszyk nadpisany obecnym koszykiem: current
		// wyświetlił się i połączył koszyki: connect
		cartStepLogEventData.f20 = config.cartRetrieveMessage ? config.cartRetrieveMessage : 'false';

		if (config.cartRetrieveLastAction) {
			var actionMapping = {
				'MERGE': 'connect',
				'OVERRIDE_LAST': 'current',
			}
			cartStepLogEventData.f20 = actionMapping[config.cartRetrieveLastAction] ? actionMapping[config.cartRetrieveLastAction] : config.cartRetrieveLastAction;
		}

		// f21 : Czy koszyk jest outletowy
		if (cartStepOrderInfo.outletWarehouseCode && cartStepOrderInfo.outletWarehouseCode.length) {
			cartStepLogEventData.f21 = cartStepOrderInfo.outletWarehouseCode
		}

		if (config.pageType && config.pageType === 'finalize') {
			// f25 : Ciasteczko _fbc z Facebooka
			cartStepLogEventData.f25 = cookie.get('_fbc') || '';

			// f26 : Ciasteczko _fbp z Facebooka
			cartStepLogEventData.f26 = cookie.get('_fbp') || '';
		}

		return filterDisallowedCartstepParams(cartStepLogEventData);
	}

	return {
		logEvent
	};
});
